import { READY_TO_RESET } from './types'

export const readyToReset = () => ({ type: READY_TO_RESET })
